class ScrollingCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const slider = this.querySelector('.scrolling--container');
    if (!slider) {
      return;
    }

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      e.preventDefault(); // Prevent text selection
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault(); // Prevent text selection
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // Adjust scroll speed
      slider.scrollLeft = scrollLeft - walk;
    });

    // Function to update the active slide
    const updateActiveSlide = () => {
      const activeLinkText = slider.querySelector('.link-text.active');
      if (activeLinkText) {
        slider.scrollTo({
          left: activeLinkText.offsetLeft - slider.offsetLeft,
          behavior: 'smooth'
        });
      }
    };

    // Observer to detect when the active class is added to .link-text elements
    const linkTexts = this.querySelectorAll('.link-text');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('active')) {
            updateActiveSlide();
          }
        }
      });
    });

    linkTexts.forEach(linkText => {
      observer.observe(linkText, { attributes: true });
    });

    // Function to set padding based on viewport width
    const setPadding = () => {
      const slider = document.querySelector('.pdp-sticky-menu-wrapper');
      const pageWidthParent = slider.closest('.page-width');
      const firstLinkText = slider.querySelector('.link-text');
      if (firstLinkText) {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth > 1200){
          firstLinkText.style.paddingLeft = '0';
        }
        else if (viewportWidth > 768 && viewportWidth <= 1024) {
          firstLinkText.style.paddingLeft = '3.2rem';
          pageWidthParent.style.paddingLeft = '0';
          pageWidthParent.style.paddingRight = '0';
        } else {
          firstLinkText.style.paddingLeft = '1.6rem';
        }
       
      }
    };

    // Initial padding setup
    setPadding();
    window.addEventListener('resize', setPadding);

    // Initial update for the active slide
    updateActiveSlide();
  }
}

customElements.define('scrolling-carousel', ScrollingCarousel);
